import { useEffect } from 'react';
import {
  EXPERIMENT_VIEWED,
  getDevice,
  trackOptimizely,
  trackPageLoad,
} from '@fff-web/fff-analytics';
import { PricesProvider } from '@fff-web/fff-payments';
import { ReactivateMyMembershipProvider } from '../../utils/ContextProviders/ReactivateContext';
import { ReactivatePlanDataProvider } from '../../utils/ContextProviders/ReactivatePlanDataContext';
import {
  COUPON_CODE_QUERY_PARAM,
  EXPIRED_SUBSCRIPTION_STATE,
  LOGGED_OUT_STATE,
} from '../constants';
import { getQueryParam } from '../MyAccount/utils/url';
import ReactivateMembership from './ReactivateMembershipContainer';

const REACTIVATE_MEMBERSHIP_FLAG = 'reactivate_membership';
const REACTIVATE_MEMBERSHIP_RULE_KEY = 'new_reactivate_membership_experience';

const ReactivateMyMembership = () => {
  useEffect(() => {
    trackPageLoad({
      properties: {
        coupon_code: getQueryParam(COUPON_CODE_QUERY_PARAM),
        subscription_state: EXPIRED_SUBSCRIPTION_STATE,
        login_state: LOGGED_OUT_STATE,
      },
    });
    trackOptimizely(EXPERIMENT_VIEWED, {
      experiment_name: REACTIVATE_MEMBERSHIP_RULE_KEY,
      variation_name: 'off',
      feature_flag_name: REACTIVATE_MEMBERSHIP_FLAG,
      device: getDevice(),
    });
  }, []);
  return (
    <ReactivateMyMembershipProvider>
      <PricesProvider>
        <ReactivatePlanDataProvider>
          <ReactivateMembership />
        </ReactivatePlanDataProvider>
      </PricesProvider>
    </ReactivateMyMembershipProvider>
  );
};

export default ReactivateMyMembership;
